import type { Step } from "react-joyride";

export const promotionRuleEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ແກ້ໄຂກົດເສັ້ນທາງການເຕີບໂຕ. ປ່ຽນແປງຂໍ້ມູນ ແລ້ວກົດບັນທຶກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-rule-edit-back"]',
    content:
      "ຍົກເລີກ ແລະ ກັບໄປຫນ້າລາຍການກົດເສັ້ນທາງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-rule-edit-form"]',
    content:
      "ແກ້ໄຂຈາກຕຳແໜ່ງ, ໄປຕຳແໜ່ງ, ຈຳນວນປີ ຫຼື ຄຳອະທິບາຍ. ກົດບັນທຶກເພື່ອອັບເດດ.",
    placement: "top",
  },
];
